import React from "react";
import { useProductStore } from "../../app/search-results/product-store/context";
import { handleAnchorClick } from "../../utils";
import Link from "../link";
import Pricing from "../pricing";
import { useI18next } from "gatsby-plugin-react-i18next";

interface StickyBarActionsProps {}

const StickyBarActions: React.FC<StickyBarActionsProps> = ({}) => {
  const [productState] = useProductStore();
  const { t } = useI18next();

  const priceText = productState?.price
    ? { prefix: "", suffix: "" }
    : { prefix: t("STARTING_FROM_SHORT"), suffix: t("PER_PERSON_SHORT") };
  const price = productState?.price ?? productState?.estimatedPrice;

  return (
    <>
      {price && (
        <Pricing {...price} {...priceText} isTotalPrice={productState?.price ? true : false} />
      )}
      {productState?.price ? (
        <Link href="#booking" internal className="cta" onClick={handleAnchorClick}>
          {t("BOOK_NOW")}
        </Link>
      ) : (
        <Link href="#offer-form" className="cta" onClick={handleAnchorClick}>
          {t("REQUEST_OFFER")}
        </Link>
      )}
    </>
  );
};

export default StickyBarActions;
